import React, {useState} from 'react';
import { Wrapper } from './styles';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useOrderContext } from '../../context/order_context';
import { useCartContext } from '../../context/cart_context';
import { Country, State, City } from 'country-state-city';
import Addresses from '../Addresses'
import {Checkbox, Flex, Select, FormLabel, FormControl} from '@chakra-ui/react';
import axios from 'axios';
import { useUserContext } from '../../context/user_context';

const countries = [Country.getCountryByCode('IN')];
const states = State.getStatesOfCountry('IN');
const cities = City.getCitiesOfCountry('IN');

function ShippingForm({ confirmShipping }) {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [saveAddressChecked, setSaveAddressChecked] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled]=useState(false)
  const { currentUser } = useUserContext();
  const {
    shipping: {
      name,
      phone_number,
      address: { line1, postal_code, city, state, country },
    },
    updateShipping,
    paymentMethod,
    updatePaymentMethod
  } = useOrderContext();

  const { cart } = useCartContext();

  const handleSelectAddress = (address1) => {
    setSelectedAddress(address1);
    // Update input fields with selected address
    updateShipping({
      target: {
        name: 'name',
        value: address1.name,
      },
    });
    updateShipping({
      target: {
        name: 'phone_number',
        value: address1.phoneNumber,
      },
    });
    updateShipping({
      target: {
        name: 'line1',
        value: address1.address.line1,
      },
    });
    updateShipping({
      target: {
        name: 'postal_code',
        value: address1.address.postal_code,
      },
    });
    updateShipping({
      target: {
        name: 'city',
        value: address1.address.city,
      },
    });
    updateShipping({
      target: {
        name: 'state',
        value: address1.address.state,
      },
    });
    updateShipping({
      target: {
        name: 'country',
        value: address1.address.country,
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const zipRegex = new RegExp('^[1-9][0-9]{5}$');

    if (!name) {
      return toast.error('Enter your Name');
    }
    if (!phone_number || !/^\d{10}$/.test(phone_number)) {
      return toast.error('Enter your phone number');
    }
    if (!line1) {
      return toast.error('Enter your Address');
    }
    if (!postal_code) {
      return toast.error('Enter your Zip Code');
    }
    if (!zipRegex.test(postal_code)) {
      return toast.error('Enter Valid Zip Code');
    }
    if (!city) {
      return toast.error('Enter your City');
    }
    if (!state) {
      return toast.error('Enter your State');
    }
    if (!country) {
      return toast.error('Enter your Country');
    }
       

    if (saveAddressChecked) {
      try {
        const userid = currentUser?.id;
          await axios.put(`${process.env.REACT_APP_BACKEND_HOST}/api/user/address/${userid}`, {
          name: name,
          phoneNumber: phone_number,
          address: {
            line1: line1,
            postal_code: postal_code,
            city: city,
            state: state,
            country: country
          }
        });
        
      } catch (error) {
        console.log(error)
        
      }
    }
    setIsBtnDisabled(true)

    return confirmShipping();


  };
  
  if (cart &&cart.length < 1) {
    return (
      <Wrapper className='page'>
        <div className='empty'>
          <h2>Your cart is empty</h2>
          <Link to='/products' className='btn' style= {{marginTop: '20px'}}>
            fill it
          </Link>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div className='checkout-wrapper'>
        <div className='checkout-card'>
          <h2 className='checkout-title'>Shipping Address</h2>

          <Addresses onSelectAddress={handleSelectAddress} />

          <div className='divider'>
            <span>Or</span>
            <p>Add a new address</p>
          </div>

          <form onSubmit={handleSubmit} className='checkout-form'>
            <input
              type='text'
              name='name'
              placeholder='Full Name'
              value={name}
              onChange={updateShipping}
              className='form-input'
            />

            <input
              type='number'
              name='phone_number'
              placeholder='Phone Number'
              value={phone_number}
              onChange={updateShipping}
              className='form-input'
            />

            <input
              type='text'
              name='line1'
              placeholder='Address'
              value={line1}
              onChange={updateShipping}
              className='form-input'
            />

            <input
              type='number'
              name='postal_code'
              placeholder='Zip Code'
              value={postal_code}
              onChange={updateShipping}
              className='form-input'
            />

            <input
              type='text'
              name='city'
              placeholder='City'
              value={city}
              onChange={updateShipping}
              className='form-input'
            />

            <select
              name='state'
              value={state}
              onChange={updateShipping}
              className='form-input'
            >
              <option value=''>Select State</option>
              {states.map((item, index) => (
                <option key={index} value={item.stateCode}>
                  {item.name}
                </option>
              ))}
            </select>

            <select
              name='country'
              value={country}
              onChange={updateShipping}
              className='form-input'
            >
              <option value=''>Select Country</option>
              {countries.map((item, index) => (
                <option key={index} value={item.countryCode}>
                  {item.name}
                </option>
              ))}
            </select>

            <label className='save-address'>
              <input
                type='checkbox'
                onChange={(e) => setSaveAddressChecked(e.target.checked)}
              />
              Save Address
            </label>

            <button
              type='submit'
              disabled={isBtnDisabled}
              className='confirm-btn'
            >
              Confirm
            </button>
          </form>
        </div>
      </div>
    </Wrapper>
  );
}

export default ShippingForm;